module.exports = __webpack_public_path__ + "static/caseStudyDesktop-1ced344c73f87416c279e6ddcd3aa0d4.png";